"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileLink = exports.FileName = exports.FileDescription = exports.FileSelectedCheck = exports.FieldTitle = exports.StyledFileUploadField = exports.PaperClipIcon = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _check = _interopRequireDefault(require("../../../../public/images/icons/check.svg"));

var _paperclipIcon = _interopRequireDefault(require("../../../../public/images/icons/paperclip-icon.svg"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PaperClipIcon = (0, _styledComponents["default"])(_paperclipIcon["default"]).withConfig({
  displayName: "FileUploadFieldstyled__PaperClipIcon",
  componentId: "sc-15y1otb-0"
})([""]);
exports.PaperClipIcon = PaperClipIcon;

var StyledFileUploadField = _styledComponents["default"].div.withConfig({
  displayName: "FileUploadFieldstyled__StyledFileUploadField",
  componentId: "sc-15y1otb-1"
})(["padding:26px 32px;border-radius:10px;", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.mode === 'dark' && (0, _styledComponents.css)(["background:var(--colors-blank);box-shadow:0px 8px 30px rgba(0,0,0,0.08);"]);
});

exports.StyledFileUploadField = StyledFileUploadField;

var FieldTitle = _styledComponents["default"].span.withConfig({
  displayName: "FileUploadFieldstyled__FieldTitle",
  componentId: "sc-15y1otb-2"
})(["display:flex;align-items:center;font-size:18px;line-height:1.4;font-weight:normal;margin:0;", ""], function (_ref2) {
  var theme = _ref2.theme;
  return theme.mode === 'dark' && (0, _styledComponents.css)(["color:var(--colors-darkBlue);"]);
});

exports.FieldTitle = FieldTitle;
var FileSelectedCheck = (0, _styledComponents["default"])(_check["default"]).withConfig({
  displayName: "FileUploadFieldstyled__FileSelectedCheck",
  componentId: "sc-15y1otb-3"
})(["height:10px;fill:var(--brandSecondary);margin-left:10px;flex-shrink:0;"]);
exports.FileSelectedCheck = FileSelectedCheck;

var FileDescription = _styledComponents["default"].div.withConfig({
  displayName: "FileUploadFieldstyled__FileDescription",
  componentId: "sc-15y1otb-4"
})(["margin-top:8px;font-size:14px;color:var(--colors-bayoux);"]);

exports.FileDescription = FileDescription;

var FileName = _styledComponents["default"].div.withConfig({
  displayName: "FileUploadFieldstyled__FileName",
  componentId: "sc-15y1otb-5"
})(["display:flex;align-items:center;color:var(--colors-bayoux);font-size:14px;line-height:22px;", "{flex-shrink:0;stroke:var(--colors-lynch);margin-right:4px;}"], PaperClipIcon);

exports.FileName = FileName;
var FileLink = (0, _styledComponents["default"])(FileName).withConfig({
  displayName: "FileUploadFieldstyled__FileLink",
  componentId: "sc-15y1otb-6"
})(["color:var(--brandPrimary);font-size:16px;text-decoration:none;", "{stroke:currentColor;}"], PaperClipIcon);
exports.FileLink = FileLink;